<header class="questionnaire">
  <ol>
    <li class="selected"><div  >Pytanie</div><span>1</span></li>
    <li class="spacer selected"></li>
    <li><span>2</span></li>
    <li class="spacer"></li>
    <li><span>3</span></li>
  </ol>
</header>
<main class="questionnaire">
  <h2  ><em>1A.</em> Jakim materiałem izolacyjnym jest ocieplony Twój dom?</h2>
  <ul>
    <li (click)="onQuestion1AClick(Izolacja.styropian)" [class.selected]="project.ankieta.pytanie1a==Izolacja.styropian"><span  >Styropianem</span></li>
    <li (click)="onQuestion1AClick(Izolacja.welnaMineralna)" [class.selected]="project.ankieta.pytanie1a==Izolacja.welnaMineralna"><span  >Wełną mineralną</span></li>
  </ul>
  <h2  ><em>1B.</em> Z jakiego materiału zbudowany jest dom?</h2>
  <ul>
    <li (click)="onQuestion1BClick(MaterialBudowlany.murowany)" [class.selected]="project.ankieta.pytanie1b==MaterialBudowlany.murowany"><span  >Cegła, beton komórkowy, ytong</span></li>
    <li (click)="onQuestion1BClick(MaterialBudowlany.drewno)" [class.selected]="project.ankieta.pytanie1b==MaterialBudowlany.drewno"><span  >Drewno</span></li>
  </ul>
</main>
<app-footer [next]="next" [prev]="prev"></app-footer>
